<template>
  <CommonLayout @reDrawMemoImage="reDrawMemoImage" header="floristHeader" footer="floristFooter" ref="commonRef">
    <MeetingLayout :itemInfo="itemInfo" :type="this.consts.meetingType.florist">
      <div class="base-color overflow-auto shadow">
        <BOverlay :show="overlayShow" rounded="sm">
          <div class="p-3">
            <div class="m-0">
              <div v-show="!showCanvas">
                <ProductSelectionSlider :projectImages="projectImages" @sendSignaling="sliderSendSignaling" @checkImageNumber="checkImageNumber" @slideChanged="onSlideChanged"/>
                <div class="mt-2 col-12 col-sm-12 text-center">
                  <BButton :variant="allowDrawing ? 'success' : 'secondary'" class="px-2" @click="openCanvasBefore" v-show="!showCanvas" :disabled="!allowDrawing">{{allowDrawing ? '手描きする' : '手描き不可'}}</BButton>
                </div>
                <div id="memo" v-if="currentProjectType != 'ブックマーク'">
                  <div v-if="isMainGuest || isMainOptOther || isGuestOptOther">
                    <BFormGroup v-if="isMainGuest || isMainOptOther">
                      <label class="mt-3" for="main-table-memo-ref">メインテーブルの打合せメモ欄</label>
                      <BFormTextarea name="mainTableMemoRef" rows="3" max-rows="21" maxlength="1021" v-model="memo['mainTableMemo_ref']" disabled></BFormTextarea>
                      <label class="mt-3" for="main-table-memo">メインテーブルの制作指示メモ欄<span class="ms-2 note-small">※最大1000文字まで入力できます。</span></label>
                      <BFormTextarea name="mainTableMemo" rows="3" max-rows="21" maxlength="1021" v-model="memo['mainTableMemo']"></BFormTextarea>
                    </BFormGroup>
                    <BFormGroup v-if="isMainGuest || isGuestOptOther">
                      <label class="mt-3" for="guest-table-memo-ref">ゲストテーブルの打合せメモ欄</label>
                      <BFormTextarea name="guestTableMemoRef" rows="3" max-rows="21" maxlength="1021" v-model="memo['guestTableMemo_ref']" disabled></BFormTextarea>
                      <label class="mt-3" for="guest-table-memo">ゲストテーブルの制作指示メモ欄<span class="ms-2 note-small">※最大1000文字まで入力できます。</span></label>
                      <BFormTextarea name="guestTableMemo" rows="3" max-rows="21" maxlength="1021" v-model="memo['guestTableMemo']"></BFormTextarea>
                    </BFormGroup>
                  </div>
                  <div v-else>
                    <BFormGroup>
                      <label class="mt-3" for="memo-ref">{{currentProjectType}}の打合せメモ欄</label>
                      <BFormTextarea name="itemMemoRef" rows="3" max-rows="21" maxlength="1021" v-model="memo['itemMemo_ref']" disabled></BFormTextarea>
                      <label class="mt-3" for="memo">{{currentProjectType}}の制作指示メモ欄<span class="ms-2 note-small">※最大1000文字まで入力できます。</span></label>
                      <BFormTextarea name="itemMemo" rows="3" max-rows="21" maxlength="1021" v-model="memo['itemMemo']"></BFormTextarea>
                    </BFormGroup>
                  </div>
                  <div class="text-center">
                    <BButton variant="primary" class="main-button-color mt-2" @click="savelargeSectionMemo" :disabled="loginStatus['referenceFlag'] === '1'">メモを保存</BButton>
                  </div>
                </div>
              </div>
              <div class="p-3 row mt-2 mb-3 pe-0" v-show="showCanvas">
                <ImageDrawCanvas
                  :memoBackGroundImage="memoBackGroundImage"
                  :memoBackGroundImageWidth="memoBackGroundImageWidth"
                  :memoBackGroundImageHeight="memoBackGroundImageHeight"
                  :drawMode="drawMode"
                  :penColor="penColor"
                  :lineWidth="lineWidth"
                  @registDrawnImage="registDrawnImage"
                  ref="imageDrawCanvas"
                />
                <div class="row col-sm-12 mt-3 mb-3">
                  <div class="col-lg-2 col-sm-3 me-2">
                    <label class="mb-0 small" for="penColor">ペンカラー</label>
                    <input class="w-100" type="color" list @change="changePenColor" v-model="penColor" name="penColor" id="penColor">
                  </div>
                  <div class="col-lg-2 col-sm-3 ms-2">
                    <label class="mb-0 small" for="drawMode">モード</label>
                    <select class="w-100 mt-1" v-model="drawMode" name="drawMode" id="drawMode">
                      <option value="source-over" selected>ペン</option>
                      <option value="destination-out">消しゴム</option>
                    </select>
                  </div>
                  <div class="col-lg-2 col-sm-3 ms-2">
                    <label class="mb-0 small" for="lineWidth">太さ</label>
                    <select class="w-100 mt-1" v-model="lineWidth" name="lineWidth" id="lineWidth">
                      <option value="2" selected>2px</option>
                      <option value="6">6px</option>
                      <option value="10">10px</option>
                      <option value="30">30px</option>
                      <option value="50">50px</option>
                      <option value="100">100px</option>
                      <option value="200">200px</option>
                      <option value="300">300px</option>
                    </select>
                  </div>
                  <div class="text-end col-lg-2 col-sm-3 me-2">
                   <BButton variant="outline-secondary" class="mt-4" style="font-size:75%" @click="clearCanvas">クリア</BButton>
                  </div>
                  <div class="col-lg-2 col-sm-3">
                   <BButton variant="outline-secondary" class="mt-4" style="font-size:75%" @click="allClearCanvas">オールクリア</BButton>
                  </div>
                </div>
                <div class="col-sm-12 text-end">
                  <BButton variant="primary" class="ms-3 main-button-color" @click="registImage" :disabled="loginStatus['referenceFlag'] === '1'">制作指示画像を保存</BButton>
                  <BButton variant="outline-secondary" class="ms-3" @click="closeCanvas">手描き終了</BButton>
                </div>
              </div>
            </div>
            <div id="operationInvalidOverlay" v-if="operationInvalidOverlay">
            </div>
          </div>
        </BOverlay>
      </div>
    </MeetingLayout>
    <CommonModal ref="commonModal" />
    <CommonModal ref="commonModalDrawnImageRegist" @confirmOk="exportDrawnImage" />
    <ImageChoiceModal ref="imageChoiceModal"  @ImageA="openCanvas(true)" @ImageB="openCanvas(false)"/>
  </CommonLayout>
</template>
<script>
import CommonLayout from '@/layout/CommonLayout'
import MeetingLayout from '@/layout/MeetingLayout'
import ProductSelectionSlider from '@/components/ProductSelectionSlider'
import CommonModal from '@/components/CommonModal'
import ImageChoiceModal from '@/components/ImageChoiceModal'
import ImageDrawCanvas from '@/components/ImageDrawCanvas'
import ProductModel from '@/models/ProductModel'
import ProductionInstructionDetailModel from '@/models/ProductionInstructionDetailModel'
import ProductionInstructionMemoImageRegistModel from '@/models/ProductionInstructionMemoImageRegistModel'
import ProductionInstructionMemoModel from '@/models/ProductionInstructionMemoModel'
import ProductionInstructionMemoRegistModel from '@/models/ProductionInstructionMemoRegistModel'
import SignalingModel from '@/models/SignalingModel'
import CommonLogModel from '@/models/CommonLogModel'
import mstore from '@/store/meeting-store'
import fstore from '@/store/florist-store'

export default {
  name: 'FloristMeetingProductSelection',
  components: { CommonLayout, MeetingLayout, ProductSelectionSlider, CommonModal, ImageChoiceModal, ImageDrawCanvas },
  data () {
    return {
      overlayShow: false,
      isSelectComplete: false,
      isSendFirstSignalingData: false,
      operationInvalidOverlay: true,
      nextProjectType: '',
      allowDrawing: true,
      showCanvas: false,
      memoBackGroundImage: '',
      memoBackGroundImageWidth: 0,
      memoBackGroundImageHeight: 0,
      memoBackGroundImageNumber: '',
      penColor: '#000000',
      drawMode: 'source-over',
      lineWidth: '2',
      projectImages: {},
      projectUchiawaseImages: {},
      itemInfo: [],
      isMainGuest: false,
      isMainOptOther: false,
      isGuestOptOther: false,
      isReDrawMemoImage: false,
      currentProjectType: '',
      currentTableRowId: '',
      suggestionType: '',
      memo: {'mainTableMemo_ref': '', 'guestTableMemo_ref': '', 'mainTableMemo': '', 'guestTableMemo': '', 'itemMemo_ref': '', 'itemMemo': ''},
      prevEvent: '',
      routeProjectType: '',
      routeTableRowId: '',
      routeId: '',
      loginStatus: '',
      currentSlideIndex: 0,
      currentSlideImage: null
    }
  },
  computed: {
    getIsTargetAtendeeActive () {
      // フローリストとの疎通確立フラグ取得
      return mstore.getters.isTargetAtendeeActive
    },
    getSignalingData () {
      return fstore.getters.signalingReceiveData
    },
    getIsOperationPossible () {
      return fstore.getters.isOperationPossible
    }
  },
  watch: {
    getIsTargetAtendeeActive: function (newData, oldData) {
      if (!this.isSendFirstSignalingData && mstore.getters.isTargetAtendeeActive) {
        this.sendSignalingApiData()
        this.isSendFirstSignalingData = true
      }
    },
    getSignalingData: function (newData, oldData) {
      try {
        newData['user'] = 'florist'
        newData['timestampMs'] = Date.now()
        CommonLogModel.apiSetStore(this.$bvModal, newData, () => {
        })
        if ('current_path' in newData) {
          const synchPass = newData['current_path'].replace('customer', 'florist')
          if (synchPass !== this.$route.path) {
            return this.$router.push(synchPass)
          }
        }

        if (newData['event'] === 'click') {
          if (newData['id'] === 'back') {
            this.$router.push(newData['target_path'])
          } else if (newData['id'] === 'selectProject') {
            this.selectProject()
          } else {
            let elm = document.getElementById(newData['id'])
            if (elm !== null) elm.click()
          }
        }
      } catch (err) {
        CommonLogModel.apiSetStore(this.$bvModal, {'timestampMs': Date.now(), 'errorMessage': err.message}, () => {
        })
      }
    },
    getIsOperationPossible: function (bool) {
      if (bool) {
        this.operationInvalidOverlay = false
      } else {
        this.operationInvalidOverlay = true
      }
    }
  },
  methods: {
    setProjectImages () {
      try {
        const store = ProductionInstructionDetailModel.getStore()
        this.projectImages = []
        this.memoBackGroundImage = ''
        this.currentSlideIndex = 0
        this.currentSlideImage = null
        if (!store.projects.images) return
        const images = Object.values(store.projects.images)
        const type2 = images.find(v => v.imageNumber === '2')
        const type3 = images.find(v => v.imageNumber === '3')

        if (this.suggestionType === 'main') {
          this.projectImages = type2 ? [type2] : []
        } else if (this.suggestionType === 'guest') {
          this.projectImages = type3 ? [type3] : []
        } else {
          this.projectImages = images
        }
        this.projectUchiawaseImages = {}
        for (var uchiawaseIndex of Object.keys(store.projects.uchiawaseImages)) {
          this.projectUchiawaseImages[uchiawaseIndex] = store.projects.uchiawaseImages[uchiawaseIndex]
        }
        this.currentSlideIndex = 0
        this.currentSlideImage = this.projectImages[0] ?? null
        this.loginStatus = JSON.parse(localStorage.getItem('loginStatus'))
      } catch (err) {
        CommonLogModel.apiSetStore(this.$bvModal, {'timestampMs': Date.now(), 'error': err}, () => {
        })
      }
    },
    setItemInfo () {
      try {
        const store = ProductionInstructionDetailModel.getStore()
        if (!store) {
          return null
        }
        this.itemInfo = store.projects.itemInfo
      } catch (err) {
        CommonLogModel.apiSetStore(this.$bvModal, {'timestampMs': Date.now(), 'error': err}, () => {
        })
      }
    },
    sliderSendSignaling (id) {
      try {
        console.log(this.prevEvent, id)
        if (id !== this.prevEvent) {
          this.prevEvent = id
          if (fstore.getters.isOperationPossible) {
            SignalingModel.sendClickEvent(id, this)
          }
        }
      } catch (err) {
        CommonLogModel.apiSetStore(this.$bvModal, {'timestampMs': Date.now(), 'error': err}, () => {
        })
      }
    },
    setApiData: async function () {
      try {
        this.overlayShow = true

        this.routeProjectType = this.$route.query.projectType
        this.routeTableRowId = this.$route.query.tableRowId
        this.routeId = this.$route.params.id

        if (localStorage.getItem('suggestionData') === null) {
          return this.$refs.commonModal.msgBoxOk('提案条件を設定してください')
        }
        this.isReDrawMemoImage = this.routeProjectType !== undefined
        this.currentProjectType = this.routeProjectType !== undefined ? this.routeProjectType : JSON.parse(localStorage.getItem('suggestionData')).projectType[0]
        if (JSON.parse(localStorage.getItem('suggestionData'))['suggestionType']) {
          this.suggestionType = JSON.parse(localStorage.getItem('suggestionData')).suggestionType[0]
        }
        this.isMainGuest = this.consts.projectType.main.indexOf(this.currentProjectType) !== -1
        // 初期化
        this.isMainOptOther = false
        this.isGuestOptOther = false
        // suggestionTypeに応じて各種フラグを切り替え
        if (this.suggestionType === 'mainopt' || this.suggestionType === 'main') {
          this.isMainGuest = false
          this.isMainOptOther = true
          this.isGuestOptOther = false
        } else if (this.suggestionType === 'guestopt' || this.suggestionType === 'guest') {
          this.isMainGuest = false
          this.isMainOptOther = false
          this.isGuestOptOther = true
        }
        if (this.routeTableRowId) {
          this.currentTableRowId = this.routeTableRowId
        }
        let params = {
          'projectType': this.currentProjectType,
          'suggestionType': this.suggestionType,
          'tableRowId': this.currentTableRowId
        }
        await ProductionInstructionDetailModel.apiSetStore(this.$bvModal, this.routeId, params, () => {
          this.overlayShow = false
        })
        this.setProjectImages()
        this.setItemInfo()

        if (this.currentProjectType !== 'ブックマーク') {
          const memo = await ProductionInstructionMemoModel.apiSetStore(this.$bvModal, params, () => {})
          for (const memoType of Object.keys(memo.largeSectionMemo)) {
            this.memo[memoType] = memo.largeSectionMemo[memoType]
          }
        }
        SignalingModel.sendClickEvent('reDrawMemoImage', this, {'projectNumber': this.routeId, 'projectType': this.currentProjectType, 'suggestionType': this.suggestionType, 'tableRowId': this.currentTableRowId})

        if (!this.isSendFirstSignalingData && mstore.getters.isTargetAtendeeActive) {
          this.isSendFirstSignalingData = true
        }
      } catch (err) {
        CommonLogModel.apiSetStore(this.$bvModal, {'timestampMs': Date.now(), 'error': err}, () => {
        })
      }
    },
    sendSignalingApiData: async function () {
      try {
        const store = ProductionInstructionDetailModel.getStore()
        if (!store) {
          return null
        }
        let apiRes = {}
        apiRes = {
          'status': store.status,
          'message': store.message
          // 'images': store.projects.images
        }
        SignalingModel.sendApiEvent('getProjectDetail', this, apiRes)
      } catch (err) {
        CommonLogModel.apiSetStore(this.$bvModal, {'timestampMs': Date.now(), 'error': err}, () => {
        })
        return null
      }
    },
    registImage: async function () {
      // cookieの打合せIDが変化しているかチェック
      let cookieProjectNumberCheckResult = await this.$refs.commonRef.cookieProjectNumberCheck()
      if (!cookieProjectNumberCheckResult) {
        this.$refs.commonModal.msgBoxOk(this.consts.errorMsg.otherCookieProjectNumber)
        return
      }
      if (this.routeProjectType !== this.$route.query.projectType ||
        this.routeTableRowId !== this.$route.query.tableRowId ||
        this.routeId !== this.$route.params.id) {
        this.$refs.commonModalDrawnImageRegist.msgBoxConfirm('URLに不整合が起こっています。ブラウザバックが行われた可能性があります。\n復元して登録も可能ですが、データ不整合が発生する可能性があります。手書き画像登録を実行しますか？')
      } else {
        this.exportDrawnImage()
      }
    },
    selectProject: async function () {
      try {
        this.overlayShow = true
        const params = {
          'selectedProjectType': this.currentProjectType,
          'selectedProjectNumber': this.routeId,
          'suggestionType': this.suggestionType
        }
        await ProductModel.apiSetStore(this.$bvModal, params, () => {
          this.overlayShow = false
        })

        SignalingModel.sendClickEvent('selectProject', this)
        this.isSelectComplete = true
        fstore.commit('setIsFirstGetHeaderEstimate', true)
        this.$refs.commonModal.msgBoxOk('商品選択が完了しました')
      } catch (err) {
        CommonLogModel.apiSetStore(this.$bvModal, {'timestampMs': Date.now(), 'error': err}, () => {
        })
      }
    },
    backPage () {
      try {
        const targetPath = '/florist/meeting/product_proposal'
        SignalingModel.sendClickEvent('back', this, {'target_path': targetPath.replace('florist', 'customer')})
        this.$router.push(targetPath)
      } catch (err) {
        CommonLogModel.apiSetStore(this.$bvModal, {'timestampMs': Date.now(), 'error': err}, () => {
        })
      }
    },
    checkImageNumber () {
      try {
        const imageNumber = this.currentSlideImage?.imageNumber
        if (imageNumber == null) return
        if (this.consts.projectType.main.indexOf(this.currentProjectType) !== -1 && ['mainopt', 'guestopt'].includes(this.suggestionType) === false) {
          const allowDrawingImageNumbers = ['1', '2', '3', '4', '5']
          this.allowDrawing = allowDrawingImageNumbers.includes(String(imageNumber))
        } else if (this.consts.projectType.noDrawing.includes(this.currentProjectType)) {
          // 手描きをしないカテゴリ(大区分)の場合に、手描きできないようにフラグをセット
          this.allowDrawing = false
        } else {
          this.allowDrawing = String(imageNumber) === '0'
        }
      } catch (err) {
        CommonLogModel.apiSetStore(this.$bvModal, {'timestampMs': Date.now(), 'errorMessage': err.message}, () => {
        })
      }
    },
    openCanvasBefore () {
      const img = this.currentSlideImage
      if (!img) return

      this.originalImage = img.originalImagePath
      this.memoBackGroundImageNumber = String(img.imageNumber)
      let sliderMainImageId = 'carousel-img-' + this.memoBackGroundImageNumber
      const selectImage = document.getElementById(sliderMainImageId).querySelectorAll('img')
      // 手書き画像判定
      let drawingFlg = false
      for (const [, value] of Object.entries(this.projectImages)) {
        if (this.memoBackGroundImageNumber === value.imageNumber) {
          drawingFlg = value.drawingFlg
          break
        }
      }

      if (drawingFlg) {
        // projectUchiawaseImagesから、選択画像に対応する画像を探す。制作指示手書き画像がない場合はprojectUchiawaseImagesは空である。
        for (const [, value] of Object.entries(this.projectUchiawaseImages)) {
          if (this.memoBackGroundImageNumber === value.imageNumber) {
            // 受注手描きあり、制作手描きありならダイアログを表示
            this.$refs.imageChoiceModal.showModal(value.imagePath, selectImage[1].src)
            return
          }
        }
      }
      // ダイアログを表示しなければそのまま手書き処理へ進む
      this.openCanvas()
    },
    openCanvas (setUchiawaseImage = false) {
      try {
        let sliderMainImageId = 'carousel-img-' + this.memoBackGroundImageNumber
        const sliderMainImage = document.getElementById(sliderMainImageId).querySelectorAll('img')
        for (let i in this.projectImages) {
          if (this.projectImages[i]['imagePath'] === sliderMainImage[1].src) {
            this.originalImage = this.projectImages[i]['originalImagePath']
          }
        }

        if (setUchiawaseImage) {
          // 打合せで作成した手書き画像を設定する
          for (const [, value] of Object.entries(this.projectUchiawaseImages)) {
            if (this.memoBackGroundImageNumber === value.imageNumber) {
              this.memoBackGroundImage = value.imagePath
              break
            }
          }
        } else {
          // 制作側で作成した手書き画像を設定する
          this.memoBackGroundImage = this.currentSlideImage.imagePath
        }

        const maxWidth = sliderMainImage[1].clientWidth
        const maxHeight = sliderMainImage[1].clientHeight
        if (sliderMainImage[1].naturalWidth > maxWidth || sliderMainImage[1].naturalHeight > maxHeight) {
          // アスペクト比計算
          const w = sliderMainImage[1].naturalWidth
          const h = sliderMainImage[1].naturalHeight
          const g = this.gcd(w, h)
          const ratioW = w / g
          const ratioH = h / g
          if (ratioW > ratioH) {
            // 横長画像(横幅 > 高さ)の場合
            this.memoBackGroundImageWidth = maxWidth
            this.memoBackGroundImageHeight = (maxWidth / ratioW) * ratioH
          } else {
            // 縦長画像(横幅 < 高さ)の場合
            this.memoBackGroundImageHeight = maxHeight
            this.memoBackGroundImageWidth = (maxHeight / ratioH) * ratioW
          }
        } else {
          this.memoBackGroundImageWidth = sliderMainImage[1].naturalWidth
          this.memoBackGroundImageHeight = sliderMainImage[1].naturalHeight
        }
        this.showCanvas = true
        if (sliderMainImage[1].src.length >= 2048) {
          SignalingModel.sendClickEvent('openCanvas', this, {'projectType': this.currentProjectType, 'imageNumber': this.memoBackGroundImageNumber})
        } else {
          SignalingModel.sendClickEvent('openCanvas', this, {'memoImageSrc': this.memoBackGroundImage})
        }
      } catch (err) {
        CommonLogModel.apiSetStore(this.$bvModal, {'timestampMs': Date.now(), 'error': err}, () => {
        })
      }
    },
    gcd (x, y) {
      try {
        if (y === 0) {
          return x
        }
        return this.gcd(y, x % y)
      } catch (err) {
        CommonLogModel.apiSetStore(this.$bvModal, {'timestampMs': Date.now(), 'error': err}, () => {
        })
        return false
      }
    },
    closeCanvas () {
      try {
        this.showCanvas = false
        SignalingModel.sendClickEvent('closeCanvas', this)
      } catch (err) {
        CommonLogModel.apiSetStore(this.$bvModal, {'timestampMs': Date.now(), 'error': err}, () => {
        })
      }
    },
    exportDrawnImage () {
      try {
        this.$refs.imageDrawCanvas.onExportDrawnImage()
      } catch (err) {
        CommonLogModel.apiSetStore(this.$bvModal, {'timestampMs': Date.now(), 'error': err}, () => {
        })
      }
    },
    exportProductionDrawnImage () {
      try {
        this.$refs.imageDrawCanvas.onExportProductionDrawnImage()
      } catch (err) {
        CommonLogModel.apiSetStore(this.$bvModal, {'timestampMs': Date.now(), 'error': err}, () => {
        })
      }
    },
    changePenColor (e) {
      try {
        this.penColor = e.target.value
      } catch (err) {
        CommonLogModel.apiSetStore(this.$bvModal, {'timestampMs': Date.now(), 'error': err}, () => {
        })
      }
    },
    registDrawnImage: async function (dataURL) {
      try {
        this.overlayShow = true
        for (const [index, value] of Object.entries(this.projectImages)) {
          if (value.imageNumber === this.memoBackGroundImageNumber) {
            value.imagePath = dataURL
            value.drawingFlg = true
            this.projectImages[index] = value
            // キャンバスの画像を更新することで再描画を促す
            this.memoBackGroundImage = dataURL
          }
        }
        const params = {
          'memoImage': dataURL.replace(/^.*,/, ''),
          'projectType': this.currentProjectType,
          'suggestionType': this.suggestionType,
          'imageNumber': this.memoBackGroundImageNumber,
          'itemCode': this.routeId,
          'isTmp': this.isReDrawMemoImage ? 0 : 1,
          'tableRowId': this.currentTableRowId
        }
        await ProductionInstructionMemoImageRegistModel.apiSetStore(this.$bvModal, params, () => {
          this.overlayShow = false
        })
        SignalingModel.sendClickEvent('showMemoImage', this, {'projectType': this.currentProjectType, 'imageNumber': this.memoBackGroundImageNumber})
      } catch (err) {
        CommonLogModel.apiSetStore(this.$bvModal, {'timestampMs': Date.now(), 'errorMessage': err.message}, () => {
        })
      }
    },
    reDrawMemoImage: async function () {
      try {
        this.showCanvas = false
        this.isReDrawMemoImage = true
        fstore.commit('setIsOperationPossible', true)
        SignalingModel.sendClickEvent('operationInvalid', this)
        await this.setApiData()
      } catch (err) {
        CommonLogModel.apiSetStore(this.$bvModal, {'timestampMs': Date.now(), 'error': err}, () => {
        })
      }
    },
    savelargeSectionMemo: async function () {
      try {
        // cookieの打合せIDが変化しているかチェック
        let cookieProjectNumberCheckResult = await this.$refs.commonRef.cookieProjectNumberCheck()
        if (!cookieProjectNumberCheckResult) {
          this.$refs.commonModal.msgBoxOk(this.consts.errorMsg.otherCookieProjectNumber)
          return
        }
        this.overlayShow = true
        let registData = {}
        const memo = document.getElementById('memo').getElementsByTagName('textarea')
        for (const key of Object.keys(memo)) {
          registData[memo[key].name] = memo[key].value
        }
        const params = {
          'largeSectionMemo': registData,
          'projectType': this.currentProjectType,
          'isMainMemo': this.isMainGuest || this.isMainOptOther,
          'isGuestMemo': this.isMainGuest || this.isGuestOptOther
        }
        await ProductionInstructionMemoRegistModel.apiSetStore(this.$bvModal, params, () => {
          this.overlayShow = false
        })
      } catch (err) {
        CommonLogModel.apiSetStore(this.$bvModal, {'timestampMs': Date.now(), 'error': err}, () => {
        })
      }
    },
    clearCanvas () {
      try {
        this.$refs.imageDrawCanvas.clearCanvas()
        SignalingModel.sendClickEvent('clearCanvas', this)
      } catch (err) {
        CommonLogModel.apiSetStore(this.$bvModal, {'timestampMs': Date.now(), 'error': err}, () => {
        })
      }
    },
    allClearCanvas () {
      let result = window.confirm('過去に制作指示作成画面で保存した手描き線も全てクリアされます。宜しいですか？')
      if (result) {
        this.memoBackGroundImage = this.originalImage
        this.clearCanvas()
      }
    },
    onSlideChanged (payload) {
      // payload例: { index: 0, image: { imageNumber, imagePath, originalImagePath, ... } }
      this.currentSlideIndex = payload?.index ?? 0
      this.currentSlideImage = payload?.image ?? null
      this.checkImageNumber()
    }
  },
  mounted () {
    try {
      this.setApiData()
      // お客様画像の手描き画面表示とブックマーク画面表示の場合、フローリスト操作中を初期状態とする
      if (this.routeProjectType && this.routeProjectType === 'お客様画像' || this.routeProjectType === 'ブックマーク') {
        fstore.commit('setIsOperationPossible', true)
        // SignalingModel.sendClickEvent('operationInvalid', this)
      }
      if (fstore.getters.isOperationPossible) {
        this.operationInvalidOverlay = false
      }
    } catch (err) {
      CommonLogModel.apiSetStore(this.$bvModal, {'timestampMs': Date.now(), 'error': err}, () => {
      })
    }
  },
  unmounted () {
    try {
      if (ProductionInstructionDetailModel.getStore()) {
        ProductionInstructionDetailModel.removeStore()
      }
      if (ProductionInstructionMemoImageRegistModel.getStore()) {
        ProductionInstructionMemoImageRegistModel.removeStore()
      }
    } catch (err) {
      CommonLogModel.apiSetStore(this.$bvModal, {'timestampMs': Date.now(), 'error': err}, () => {
      })
    }
  }
}
</script>
<style scoped type="text/css">
.slick-next, .slick-prev, .slick-dots li, .slick-track {
  pointer-events: none;
}
#operationInvalidOverlay{
  position: absolute;
  left: 0; top: 0;
  width: 100%; height: 100%;
  opacity: 0;
  z-index: 2;
}
</style>
